<template>
    <Guest>
        <h1 class="login__title mb-6 text-center lg:text-left">
            {{ $__('login.reset_page.title_line_1') }} <br/>
            {{ $__('login.reset_page.title_line_2') }}
        </h1>

        <div class="text-green-600" v-if="$page.props.success">
            {{ $__($page.props.success) }}
        </div>

        <form @submit.prevent="submit" class="-mt-2">
            <Password name="password" v-model="form.password" :error="this.$page.props.errors.password"
                        label="login.reset_page.form_password_1"/>

            <Password name="password_confirmation" v-model="form.password_confirmation" :error="this.$page.props.errors.password_confirmation"
                            label="login.reset_page.form_password_2"/>

            <div class="mt-10 w-full">
                <Button :class="'w-full lg:w-full login__button'">
                    {{ $__('login.reset_page.submit') }}
                </Button>
            </div>
        </form>

        <a :href="route($page.props.locale + '.login')"
            :class="'mt-4 inline-block w-full text-center login__link cursor-pointer'">{{ $__('login.reset_page.return') }}</a>
    </Guest>
</template>

<script>
import Guest from '@/Layouts/Guest';
import InputGroupFull from '@/Components/Form/InputGroupFull';
import Password from '@/Components/Form/Password';
import Button from '@/Components/Form/Button';

export default {
    components: { Button, Password, InputGroupFull, Guest },
    data: () => ({
        form: {
            password: null,
            password_confirmation: null,
        },
    }),
    methods: {
        submit() {
            this.$inertia.post(route(this.$page.props.locale + '.password.send-change', { 'secret': this.$page.props.secret } ), this.form)
        },
    }
};
</script>
